<uib-tabset active="active">
    <!-- Allgemeine Infos -->
    <uib-tab index="0" heading="Static title">
        <div class="row">
            <div class="col-xs-12 col-md-3">
                <label>Nummer/ID</label>
                <input type="text" ng-model="vm.entry.sprnum" ng-blur="vm.save(vm.entry)" name="sprnum" class="form-control">
            </div>
            <div class="col-xs-12 col-md-9">
                <label>Bezeichnung</label>
                <input type="text" ng-model="vm.entry.name" ng-blur="vm.save(vm.entry)" name="name" class="form-control">
            </div>
        </div>
    </uib-tab>
    <!-- KK spezifische Infos -->
    <uib-tab index="$index + 1" ng-repeat="sv in vm.entry.svs" heading="{{sv.svname}}">
        <div class="row">
            <div class="col-xs-12 col-md-3">
                <label>KK Nummer/ID</label>
                <input type="text" ng-model="sv.num" ng-blur="vm.save(vm.entry)" name="sprnum" class="form-control">
            </div>
            <div class="col-xs-12 col-md-9">
                <label>Bezeichnung <span class="btn btn-primary btn-xs" uib-tooltip="Text aus Spr Katalog kopieren"
                                         ng-click="sv.text = vm.entry.name"><i class="fa fa-copy"></i> </span> </label>
                <input type="text" ng-model="sv.text" ng-blur="vm.save(vm.entry)" name="name" class="form-control">
            </div>
        </div>
<!--        <div class="row">
            <div class="col-xs-12 col-md-12">
                <label>Begründung erforderlich</label>
                <input type="text" ng-model="sv.reason" ng-blur="vm.save(vm.entry)" name="reason" class="form-control">
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <label>Erklärung/Erläuterung</label>
                <input type="text" ng-model="sv.explanation" ng-blur="vm.save(vm.entry)" name="explanation" class="form-control">
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <label>Ausführliche Erklärung</label>
                <textarea ng-model="sv.explantionext" ng-blur="vm.save(vm.entry)" name="explainext" class="form-control"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <label>Beschränkte Verrechenbarkeit nach Fachrichtung </label>
                <input type="text" ng-model="sv.doc" ng-blur="vm.save(vm.entry)" name="doc" class="form-control">
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <label>Limits</label>
                <input type="text" ng-model="sv.limit" ng-blur="vm.save(vm.entry)" name="limit" class="form-control">
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <label>Ausführliche Erklärung der Limits</label>
                <textarea ng-model="sv.limitext" ng-blur="vm.save(vm.entry)" name="limitext" class="form-control"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <label>Punkte</label>
                <input type="text" ng-model="sv.points" ng-blur="vm.save(vm.entry)" name="points" class="form-control">
            </div>
            <div class="col-xs-12 col-md-4">
                <label>Preis</label>
                <input type="text" ng-model="sv.price" ng-blur="vm.save(vm.entry)" name="price" class="form-control">
            </div>
            <div class="col-xs-12 col-md-4">
                <label>Regiezuschlag</label>
                <input type="text" ng-model="sv.regie" ng-blur="vm.save(vm.entry)" name="regie" class="form-control">
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <label>Materialzuschlag</label>
                <input type="text" ng-model="sv.material" ng-blur="vm.save(vm.entry)" name="material" class="form-control">
            </div>
            <div class="col-xs-12 col-md-12">
                <label>Ausführliche Erklärung der Meterialzuschläge</label>
                <textarea ng-model="sv.materialext" ng-blur="vm.save(vm.entry)" name="materialext" class="form-control"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-3">
                <label>Nicht zusammen mit</label>
                <input type="text" ng-model="sv.exclude" ng-blur="vm.save(vm.entry)" name="exclude" class="form-control">
            </div>
            <div class="col-xs-12 col-md-9">
                <label>Nur zusammen mit</label>
                <input type="text" ng-model="sv.onlywith" ng-blur="vm.save(vm.entry)" name="onlywith" class="form-control">
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <label>Ausführliche Erklärung der Ausschließungsgründe</label>
                <textarea ng-model="sv.excludext" ng-blur="vm.save(vm.entry)" name="excludext" class="form-control"></textarea>
            </div>
        </div>-->

    </uib-tab>

</uib-tabset>


<!--<div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
    <h3><i class="fa fa-check"></i> unicat erfolgreich gespeichert!</h3>
</div>
<div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
    <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen unicat wurde abgebrochen!</h3>
</div>
<div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
    <h3>
        <i class="fa fa-warning"></i> unicat konnte nicht gespeichert werden,
        der Fehler wurde protokolliert!
    </h3>
</div>
-->